<template>
	<div class="row control">
		<div class="card__content" style="direction: rtl;">
			<div class="col-lg-8 col-md-12 col-sm-12" style="direction: ltr;">
				<div class="row">
					<div class="col-sm-10">
						<div v-show="active === 'title'" key="title">
							<slot name="title"></slot>
						</div>
						<div v-show="active === 'subTitle'" key="subTitle">
							<slot name="subTitle"></slot>
						</div>
						<div v-show="active === 'media'" key="media">
							<slot name="media"></slot>
						</div>
						<div v-show="active === 'button'" key="button">
							<div>
								<ul class="nav nav-tabs" style="border-bottom: 1px solid rgba(0, 0, 0, 0.125);">
									<li
										class="nav-item"
										v-for="(button, index) in buttons"
										:key="'list' + index"
										@click="buttonPage = index"
									>
										<span :class="'nav-link card-link '+ ( buttonPage == index ? 'active' : '')">
											<span>{{$t('button', ' ' + (index+1))}}&nbsp;</span>
											<span class="text-left" @click="removeButton(index)" :title="$t('delete')">
												<i class="fa fa-remove fa-sm"></i>
											</span>
										</span>
									</li>
									<li class="nav-item" v-if="hasNewButton">
										<a
											href="#"
											target="_self"
											:class="'nav-link card-link bl-0'"
											@click.prevent="newButton"
											:title="$t('new')"
										>
											<span class="text-left">
												<i :class="'fa fa-plus fa-sm ' + (!hasNewButton ? 'text-muted' : '')"></i>
											</span>
										</a>
									</li>
								</ul>
								<div
									class="mt-0 pr-3 pl-3 pb-0 bt-0"
									:style="buttons.length ? 'border: 1px solid rgba(0, 0, 0, 0.125);' : ''"
								>
									<div v-for="(button, ii) in buttons" class="row" :key="'slot_button_' + ii">
										<!-- <div class="col-lg-2 pb-3 pt-3 pr-0" v-show="buttonPage == ii"> -->
										<!-- <b-list-group>
												<b-list-group-item
													href="#"
													:class="(buttonSlotActive === 'label' ? 'active' : '')"
													@click="buttonSlotActive = 'label'"
													style="padding: 0.5rem 1rem;"
												>{{$t('label')}}</b-list-group-item>
												<b-list-group-item
													href="#"
													:class="(buttonSlotActive === 'value' ? 'active' : '')"
													@click="buttonSlotActive = 'value'"
													style="padding: 0.5rem 1rem;"
												>{{$t('value')}}</b-list-group-item>
										</b-list-group>-->
										<!-- </div> -->
										<div class="col-lg-12 pt-3" v-show="buttonPage == ii">
											<!-- <div v-show="buttonSlotActive === 'label'"> -->
											<slot :name="'button.' + ii"></slot>
											<!-- </div> -->
											<!-- <div v-show="buttonSlotActive === 'value'"> -->
											<!-- <slot :name="'button.value.' + ii"></slot> -->
											<!-- </div> -->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-2">
						<b-list-group>
							<template v-for="(l, i) in list">
								<b-list-group-item
									href="#"
									:active="l.slot === active"
									:disabled="l.disabled"
									:class="'flex-column align-items-start' + (l.disabled ? 'disabled' : '')"
									:key="i"
									@click.prevent="active = l.slot"
									:title="l.title"
								>
									<small class="text-center">
										<div>
											<i :class="l.iconClass"></i>
											<small class>{{ l.title }}</small>
										</div>
									</small>
								</b-list-group-item>
							</template>
						</b-list-group>
					</div>
				</div>
			</div>
			<div class="col-lg-4 col-md-12 col-sm-12 text-center">
				<div class="brand-card mb-0">
					<div
						class="brand-card-header mb-0 brand-card-header__media"
						:title="$t('edit')"
						@click="toogleTo('media')"
						:style="mediaBackground"
						v-html="mediaIcon"
					></div>
					<div class="card-body p-0 clearfix brand-card-body" style>
						<div class="text pr-2 pl-2">
							<div
								class="h4 d-block text-left pt-2"
								v-if="title && title.length"
								:title="$t('edit')"
								@click="toogleTo('title')"
								v-html="autoCompleteTextToHTML(title)"
							></div>
							<div
								class="h4 d-block text-left pt-2 text-muted"
								v-else
								:title="$t('edit')"
								@click="toogleTo('title')"
							>{{$t('title')}}</div>
							<small
								v-if="subTitle && subTitle.length"
								class="text-muted font-weight-bold d-block text-left pt-0 pb-2"
								:title="$t('edit')"
								@click="toogleTo('subTitle')"
								v-html="autoCompleteTextToHTML(subTitle)"
							></small>
							<small
								v-else
								class="text-muted font-weight-bold d-block text-left pt-0 pb-2"
								:title="$t('edit')"
								@click="toogleTo('subTitle')"
							>{{$t('subtitle')}}</small>
						</div>
						<template v-for="(btn, i) in buttons">
							<button
								:key="'buttons__' + i"
								v-if="(btn.item_label_key && btn.item_label_key.length) || (btn.item_label_default_value && btn.item_label_default_value.length)"
								type="button"
								class="btn btn-outline-secondary btn-lg btn-block bl-0 br-0 bb-0 m-0"
								:title="$t('edit')"
								@click="toogleTo('button');buttonPage = i;"
								v-html="btn.item_label_key || btn.item_label_default_value"
							></button>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'command-response-card',
		props: {
			title: {
				type: String,
				default: () => '',
			},
			subTitle: {
				type: String,
				default: () => '',
			},
			autoCompleteModules: {
				type: Object,
				default: () => {},
			},
			buttons: {
				type: Array,
				default: () => [],
			},
			checkMediaBackground: {
				type: Boolean,
				default: false,
			},
			media: {
				type: String,
				default: () => '',
			},
		},
		data() {
			return {
				list: [
					{
						title: 'title',
						iconClass: 'icon-pencil icons font-2xl d-block',
						slot: 'title',
						disabled: false,
					},
					{
						title: 'sub title',
						iconClass: 'icon-pencil icons font-2xl d-block',
						slot: 'subTitle',
						disabled: false,
					},
					{
						title: 'media',
						iconClass: 'icon-picture icons font-2xl d-block',
						slot: 'media',
						disabled: false,
					},
					{
						title: 'button',
						iconClass: 'icon-layers icons font-2xl d-block',
						slot: 'button',
						disabled: false,
					},
				],
				active: 'title',
				buttonSlotActive: 'label',
				buttonPage: 0,
				hasNewButton: true,
				mediaBackground: '',
				mediaIcon: '',
			}
		},
		methods: {
			toogleTo(slot) {
				for (var i = 0; i < this.list.length; ++i) {
					if (this.list[i].slot === slot) {
						if (!this.list[i].disabled) {
							this.active = slot
						}
						break
					}
				}
			},
			autoCompleteTextToHTML(str) {
				if (Object.keys(this.autoCompleteModules).length)
					return autoCompleteTextToHTML(str, this.autoCompleteModules)
				return str
			},

			removeButton(pos) {
				setTimeout(() => {
					if (this.buttons[pos + 1]) {
						this.buttonPage = pos + 1
					} else if (this.buttons[pos - 1]) {
						this.buttonPage = pos - 1
					}
				}, 0)
				this.$emit('onRemoveButtonClick', pos)
			},
			newButton() {
				if (this.hasNewButton) {
					this.$emit('onNewButtonClick')
				}
			},
			setDefaultMediaStyle() {
				this.mediaBackground = 'background-color: #29363d;'
				this.mediaIcon = '<i class="icon-picture icons font-5xl d-block " style="color: #fff;"></i>'
			},
		},
		watch: {
			buttons(bs) {
				if (!bs.length) {
					this.buttonPage = 0
				}
				if (bs.length >= 3) {
					this.hasNewButton = false
				} else {
					this.hasNewButton = true
				}
			},
			media(value) {
				var this$1 = this
				if (this.checkMediaBackground) {
					// check is a valid url
					if (is_url(value)) {
						// check is a valid image
						var img = new Image()
						img.onload = function() {
							this$1.mediaBackground = 'background-image: url(' + value + ');'
							this$1.mediaIcon = ''
						}
						img.onerror = function() {
							this$1.setDefaultMediaStyle()
						}
						img.src = value
					} else if (is_base_64(value)) {
						this$1.mediaBackground = 'background-image: url(' + value + ');'
						this$1.mediaIcon = ''
					} else {
						this.setDefaultMediaStyle()
					}
				}
			},
		},
		mounted() {
			this.setDefaultMediaStyle()
		},
		computed: {
			//
		},
	}
</script>
